module.exports = __webpack_public_path__ + "static/media/piggy-bank.41c38283.svg";